import { memo } from 'react';
import { MemberRemoveTemplate } from 'components/templates/MemberRemoveTemplate';

type Props = {};

export const MemberRemove = memo((_props: Props) => {
	return <MemberRemoveTemplate />;
});
